import { lazy } from 'react';

export const Climate = lazy(() => import('./Climate'));
export const ClimateModelValidator = lazy(() => import('./ModelValidator'));

export * from './getReleaseNotes';
